import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-organization-info',
	styleUrls: ['./organization-info.component.scss'],
	templateUrl: './organization-info.component.html',
})
export class OrganizationInfoComponent {
	@Input() cnpj: string = '';
	@Output() editGroup: EventEmitter<string> = new EventEmitter();
	@Input() id: string = '';
	@Input() isFavorite: boolean = false;
	@Input() isMatriz: boolean = false;
	@Input() name: string = '';
	@Input() state: string = '';
	@Output() toggleFavoriteClicked: EventEmitter<boolean> = new EventEmitter();
	@Input() totalBeneficiaries: number = 0;
	@Input() totalUsers: number = 0;

	onEditGroup(name: string): void {
		this.editGroup.emit(name);
	}

	onToggleFavorite(isFavorite: boolean): void {
		this.toggleFavoriteClicked.emit(isFavorite);
	}
}
